export class Address {
  constructor(
    private _address: string,
    private _addressLine2: string,
    private _zipCode: string,
    private _city: string,
    private _province: string,
    private _country: string = null,
    private _fiscalCode: string = null,
    private _vat: string = null,
    private _name: string = null,
    private _surname: string = null,
    private _companyName: string = null,
    private _pec: string = null,
    private _sdiCode: string = null
  ) { }

  get name(): string {
    return this._name;
  }

  get surname(): string {
    return this._surname;
  }

  get address(): string {
    return this._address;
  }

  get addressLine2(): string {
    return this._addressLine2;
  }

  get zipCode(): string {
    return this._zipCode;
  }

  get city(): string {
    return this._city;
  }

  get province(): string {
    return this._province;
  }

  get country(): string {
    return this._country;
  }

  get fiscalCode(): string {
    return this._fiscalCode;
  }

  get vat(): string {
    return this._vat;
  }

  get companyName(): string {
    return this._companyName;
  }
  get pec(): string {
    return this._pec;
  }
  get sdiCode(): string {
    return this._sdiCode;
  }


  static fromRawPerson(data: any): Address {
    return new Address(
      data.address,
      data.address_line_2,
      data.zip_code,
      data.city,
      data.province,
      data.country,
      data.fiscal_code,
      null,
      data.name,
      data.surname,
      null,
      data.pec,
      data.sdi_code
    );
  }

  static fromRawFreelancer(data: any): Address {
    return new Address(
      data.address,
      data.address_line_2,
      data.zip_code,
      data.city,
      data.province,
      data.country,
      data.fiscal_code,
      data.vat,
      data.name,
      data.surname,
      null,
      data.pec,
      data.sdi_code
    );
  }

  static fromRawCompany(data: any): Address {
    return new Address(
      data.address,
      data.address_line_2,
      data.zip_code,
      data.city,
      data.province,
      data.country,
      data.fiscal_code,
      data.vat,
      null,
      null,
      data.company_name,
      data.pec,
      data.sdi_code
    );
  }

  withFiscalCode(fiscalCode: string): Address {
    return new Address(
      this._address,
      this._addressLine2,
      this._zipCode,
      this._city,
      this._province,
      this._country,
      fiscalCode,
      this._vat,
      this._name,
      this._surname,
      this._companyName,
      this._pec,
      this._sdiCode
    );
  }

  withVat(vat: string): Address {
    return new Address(
      this._address,
      this._addressLine2,
      this._zipCode,
      this._city,
      this._province,
      this._country,
      this._fiscalCode,
      vat,
      this._name,
      this._surname,
      this._companyName,
      this._pec,
      this._sdiCode
    );
  }

  withName(name: string): Address {
    return new Address(
      this._address,
      this._addressLine2,
      this._zipCode,
      this._city,
      this._province,
      this._country,
      this._fiscalCode,
      this._vat,
      name,
      this._surname,
      this._companyName,
      this._pec,
      this._sdiCode
    );
  }

  withSurname(surname: string): Address {
    return new Address(
      this._address,
      this._addressLine2,
      this._zipCode,
      this._city,
      this._province,
      this._country,
      this._fiscalCode,
      this._vat,
      this._name,
      surname,
      this._companyName,
      this._pec,
      this._sdiCode
    );
  }

  withCompanyName(companyName: string): Address {
    return new Address(
      this._address,
      this._addressLine2,
      this._zipCode,
      this._city,
      this._province,
      this._country,
      this._fiscalCode,
      this._vat,
      this._name,
      this._surname,
      companyName,
      this._pec,
      this._sdiCode
    );
  }

  withPec(pec: string): Address {
    return new Address(
      this._address,
      this._addressLine2,
      this._zipCode,
      this._city,
      this._province,
      this._country,
      this._fiscalCode,
      this._vat,
      this._name,
      this._surname,
      this._companyName,
      pec,
      this._sdiCode
    );
  }

  withSdiCode(sdiCode: string): Address {
    return new Address(
      this._address,
      this._addressLine2,
      this._zipCode,
      this._city,
      this._province,
      this._country,
      this._fiscalCode,
      this._vat,
      this._name,
      this._surname,
      this._companyName,
      this._pec,
      sdiCode
    );
  }

  toRaw(type) {
    const addressRaw = {
      address: this._address,
      zip_code: this._zipCode,
      province: this._province,
      city: this._city,
      country: this._country,
    };

    if (this._addressLine2) {
      addressRaw['address_line_2'] = this._addressLine2;
    }

    switch (type) {
      case 'person':
        addressRaw['fiscal_code'] = this._fiscalCode;
        addressRaw['name'] = this._name;
        addressRaw['surname'] = this._surname;
        if(this._pec) {
          addressRaw['pec'] = this._pec;
        }
        addressRaw['sdi_code'] = this._sdiCode;
        break;

      case 'freelancer':
        addressRaw['fiscal_code'] = this._fiscalCode;
        addressRaw['vat'] = this._vat;
        addressRaw['name'] = this._name;
        addressRaw['surname'] = this._surname;
        if(this._pec) {
          addressRaw['pec'] = this._pec;
        }
        addressRaw['sdi_code'] = this._sdiCode;
        break;

      case 'company':
        addressRaw['fiscal_code'] = this._fiscalCode;
        addressRaw['vat'] = this._vat;
        addressRaw['company_name'] = this._companyName;
        if(this._pec) {
          addressRaw['pec'] = this._pec;
        }
        addressRaw['sdi_code'] = this._sdiCode;
        break;
    }
    return addressRaw;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/model/address.ts